import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getItemModelTitle } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getSearchUrlWithParams } from '@/utils/urls';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';
import { SubtleRouteLink } from '@/components/RouteLinks/RouteLinks';
import { TimedPlusStatus } from '@/components/ItemBidding/components/Estimate/components/Estimate-12hCountdownTimer/components/TimedPlusCountdown/types/TimedPlusStatus.enum';
import { useAppSelector } from '@/redux/hooks';
import styled from 'styled-components';

export type TimedPlusItemBiddingLotWithdrawnProps = {
    itemId: number;
};

const TimedPlusItemBiddingLotWithdrawn = ({ itemId }: TimedPlusItemBiddingLotWithdrawnProps) => {
    const title = useAppSelector((state) => getItemModelTitle(state, itemId));

    return (
        <StyledContent>
            <StyledHeader color="secondary">
                <FormattedMessage id={`itemPage.biddingInfo.timedPlus.${TimedPlusStatus.Withdrawn}.header`} />
            </StyledHeader>
            <div className="hui-text-body-primary text-text-secondary">
                <FormattedMessage id={`itemPage.biddingInfo.timedPlus.${TimedPlusStatus.Withdrawn}.description`} />
            </div>
            <SubtleRouteLink
                to={getSearchUrlWithParams({
                    keyword: title,
                    page: 1,
                    status: 'online',
                })}
            >
                <FormattedMessage id={`itemPage.biddingInfo.timedPlus.${TimedPlusStatus.Withdrawn}.seeSimilarItems`} />
            </SubtleRouteLink>
        </StyledContent>
    );
};

export default TimedPlusItemBiddingLotWithdrawn;

const StyledContent = styled.div`
    flex: 1 1 auto;
    // borders from BiddingBox cause the padding to have one extra pixel than desired
    padding: 23px;
    @media print {
        padding: 0;
    }

    & > a {
        width: fit-content;
    }

    & > * {
        margin-bottom: 8px;
    }
    & > *:last-child {
        margin-bottom: 0;
    }

    > div:not(:first-child),
    a {
        @media print {
            display: none;
        }
    }
    > div:first-child {
        @media print {
            margin: 0;
        }
    }
`;

const StyledHeader = styled(H5)`
    text-transform: uppercase;
`;
